import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReferAFriendDataDispatcher } from './refer-a-friend-data.dispatcher';
import { ReferAFriendDataEffects } from './refer-a-friend-data.effects';
import { FEATURE_NAME, reducer } from './refer-a-friend-data.reducer';
import { ReferAFriendDataService } from './refer-a-friend-data.service';
import { ReferAFriendDataStore } from './refer-a-friend-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ReferAFriendDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class ReferAFriendDataModule {
  static forRoot(): ModuleWithProviders<ReferAFriendDataModule> {
    return {
      ngModule: ReferAFriendDataModule,
      providers: [
        ReferAFriendDataDispatcher,
        ReferAFriendDataService,
        ReferAFriendDataStore,
      ],
    };
  }
}
